import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Airport } from "../../../types";
import { DeleteAirports } from "./airportSlice";

// Async Thunks
export const fetchAirports = createAsyncThunk<Airport[], void, { rejectValue: string }>("airports/fetchAirport", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<Airport[]>>(apiEndpoints.airport.getAll);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch airports.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});
export const createAirport = createAsyncThunk<Airport, Airport, { rejectValue: string }>("airports/createAirport", async (newAirportData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<Airport>>(apiEndpoints.airport.create, { data: newAirportData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add airport.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteAirports = createAsyncThunk<DeleteAirports, { id: string }, { rejectValue: string }>("airports/deleteAirport", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteAirports>>(`${apiEndpoints.airport.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete airport.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateAirport = createAsyncThunk<Airport, Airport, { rejectValue: string }>("airports/updateAirport", async (updatedAirportData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<Airport>>(`${apiEndpoints.airport.update}/${updatedAirportData?.id}`, { data: updatedAirportData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update airport.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
